import { useMediaQuery } from '@mui/material';
import React from 'react';
import isoCertifications from '../../../../../../../assets/images/empresa/sobre-nos/reconhecimentos.png';
import DefaultText from '../../../../../../../components/typography/default-text';
import CertificationsDesktop from './CertificationsDesktop';
import CertificationsMobile from './CertificationsMobile';
import styles from './styles.module.css';


const Certifications: React.FC = () => {

  const isMobile = useMediaQuery('(max-width: 899px)');


  return (
    <div className={styles["sub-page-content"]}>
      <div className={styles['certifications-banner-container']}>
        <div className={styles['certifications-banner-text-content']}>
          <DefaultText color="var(--primary-blue)" size={"medium"} sx={{ fontFamily: "Montserrat-Bold", maxWidth: "600px", marginBottom: "16px" }}>
            <i>Reconhecimento</i>
          </DefaultText>
          <DefaultText color="var(--primary-blue)" size={"small"} sx={{ fontFamily: "Montserrat-Regular", maxWidth: "600px", marginBottom: "24px" }}>
            A Telemont é reconhecida no mercado como uma referência em qualidade, inovação e compromisso com seus clientes.
            Com uma trajetória sólida, a empresa se destaca pela eficiência e pela capacidade técnica de suas equipes.
            Esses reconhecimentos são o reflexo do nosso trabalho contínuo em busca da excelência.
          </DefaultText>
        </div>
        <img src={isoCertifications} alt="Certificações ISO: 9001, 14001 e 45001" className={styles['img-iso-certifications']} />
      </div>
      {!isMobile ? <CertificationsDesktop /> : <CertificationsMobile />}
    </div >
  );
};

export default Certifications;